import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const redirecionarSeForResponsavel = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];
  // eslint-disable-next-line
  if (!currentUser) {
    next({ name: "login" });
    return true; // Indica que houve redirecionamento
  }
  if (currentUser.roleName === "aluno") {
    // Evita redirecionamento se já está na rota correta
    if (to.name === "acessoResponsavel.home") {
      return false;
    }
    next({ name: "acessoResponsavel.home" });
    return true; // Indica que houve redirecionamento
  }
  return false; // Não houve redirecionamento
};

export default redirecionarSeForResponsavel;
